// src/pages/vendor/Pickups/components/PickupStatusBadge.tsx

import React from 'react';
import { Clock, CheckCircle, XCircle, AlertCircle, Loader2, Truck, FileEdit } from 'lucide-react';

interface PickupStatusBadgeProps {
    status: 'draft' | 'pending' | 'in_transit' | 'received' | 'cancelled' | 'rejected';
    size?: 'sm' | 'md' | 'lg';
}

const PickupStatusBadge: React.FC<PickupStatusBadgeProps> = ({ status, size = 'md' }) => {
    const config = {
        draft: {
            color: 'bg-gray-100 text-gray-800 border-gray-200',
            icon: FileEdit,       // or Pencil
            label: 'Draft',
        },
        pending: {
            color: 'bg-blue-100 text-blue-800 border-blue-200',
            icon: AlertCircle,
            label: 'Pending Pickup',
        },
        in_transit: {
            color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
            icon: Truck,
            label: 'In Transit',
        },
        received: {
            color: 'bg-green-100 text-green-800 border-green-200',
            icon: CheckCircle,
            label: 'Received',
        },
        cancelled: {
            color: 'bg-red-100 text-red-800 border-red-200',
            icon: XCircle,
            label: 'Cancelled',
        },
        rejected: {
            color: 'bg-red-100 text-red-800 border-red-200',
            icon: XCircle,
            label: 'Rejected',
        },
    };

    const { color, icon: Icon, label } = config[status] ?? config.draft;

    const sizeClasses = {
        sm: 'px-1.5 py-0.5 text-xs',
        md: 'px-2.5 py-1 text-xs',
        lg: 'px-3 py-1.5 text-sm'
    };

    return (
        <span className={`inline-flex items-center gap-1.5 rounded-full border ${color} ${sizeClasses[size]}`}>
            <Icon className={`${size === 'sm' ? 'h-3 w-3' : size === 'lg' ? 'h-4 w-4' : 'h-3.5 w-3.5'}`} />
            {label}
        </span>
    );
};

export default PickupStatusBadge;